<template>
	<div class="big" >
		<div class="div_html" style="font-size: 0;"  v-html="userList.content">

		</div>
	</div>
		
</template>
<script>
	import request from '@/utils/request'
	export default {
		components: {

		},
		data() {
			return {
					userList:'' ,
			}
		},
		mounted() {
			this.initData();
			
		},
		methods: {
			initData() {
				let _this = this;
				let url = Global.env + Global.apiCore.helpDetails+"/"+this.$route.query.id;
				// let url = Global.env + Global.apiCore.helpList;
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							_this.userList = response.data;
							return resolve()
						}
					}).catch(error => {
						return reject(error);
					})
				})
			}
		}
	}
</script>

<style>
	.big {
		width: 100%;
		text-align: justify;
	}
	.div_html {
		margin: 0 auto;
		width: 96%;
	}
	.div_html p{
		line-height: 0.48rem;
		color: #666666;
		font-size: 0.28rem !important;
	}
	.div_html img{
		width: 100%;
		margin: 0 auto;
	}
</style>
